import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Parhato2ProductSubscription, Product } from "@core/types";
import { productsClient } from "@core/clients";
import { queryClient } from "../../config/query-client";

type Props = {
  productId: Product["id"];
  options?: UseMutationOptions<Parhato2ProductSubscription | null, unknown, void, [string, Product["id"]]>;
};

const useProductSubscriptionMutation = ({ productId, options }: Props) => {
  return useMutation(
    ["product-subscription/add", productId],
    async () => {
      return productsClient.addProductSubscription(productId);
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["product-subscriptions"]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};

export default useProductSubscriptionMutation;
